
import EsMessage from '@/components/EsMessage.vue';
import EsLogo from '@/components/EsLogo.vue';

export default {
    name: 'LayoutCentered',
    components: {
        EsMessage,
        EsLogo,
    },
    computed: {
        homeUrl() {
            return this.$config.WWW_DOMAIN;
        },
        messages() {
            return this.$store.state.messages.messages;
        },
    },
};
